import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Box,
    Typography,
    Stack,
    useMediaQuery
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { cookieCategories } from "../cookieConfig";
import { CookieTable } from "./cookieTable";

interface ProviderListDialogProps {
    open: boolean;
    onClose: () => void;
}

export const ProviderListDialog: React.FC<ProviderListDialogProps> = ({
    open,
    onClose
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const totalCookies = cookieCategories.reduce((sum, cat) => sum + cat.cookies.length, 0);
    const uniqueProviders = new Set(
        cookieCategories.flatMap(cat => cat.cookies.map(c => c.provider))
    ).size;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={isMobile}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle sx={{ display: "flex", alignItems: "center" }}>
                Liste aller Anbieter
                <Box sx={{ flexGrow: 1 }} />
                <IconButton onClick={onClose}>
                    <Close />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Stack spacing={3}>
                    {cookieCategories.map((category) => {
                        if (category.cookies.length === 0) return null;

                        return (
                            <Box key={category.id}>
                                <Typography variant="h6" gutterBottom>
                                    {category.name}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ mb: 2 }}
                                >
                                    {category.description}
                                </Typography>
                                <CookieTable cookies={category.cookies} />
                            </Box>
                        );
                    })}

                    {totalCookies > 0 && (
                        <Box sx={{ pt: 2, borderTop: 1, borderColor: "divider" }}>
                            <Typography variant="body2" color="text.secondary" align="center">
                                Insgesamt {totalCookies} Cookies von {uniqueProviders} Anbietern
                            </Typography>
                        </Box>
                    )}
                </Stack>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Schließen</Button>
            </DialogActions>
        </Dialog>
    );
};